$(document).ready(function () {	
    const components = document.querySelectorAll('.cmp-flindersonline-saved-courses');
    if (components.length > 0) {
        components.forEach(component => {
            const endpoint = component.dataset.endpoint;
            const resourcePath = component.dataset.resourcePath;            
            const tagNew = component.dataset.displaytagnew;
            const tagMidYear = component.dataset.displaytagmidyear;
            const tagScholar = component.dataset.displaytagscholar;
            const tagOnline = component.dataset.displaytagonline;


            function initSavedCourses(){
                const saved = localStorage.getItem('flinders_saved_courses');
                let paths = saved ? JSON.parse(saved) : [];

                if(paths.length > 0){
                    $.ajax({
                        url: endpoint,
                        type: "POST",
                        data: JSON.stringify({"paths": paths, "resource": resourcePath}),
                        contentType: 'application/json',
                        success: function(response){
                            loadCourses(response);
                        }
                    });
                }else{
                    loadEmptyCourses();
                }
            }

            function loadEmptyCourses(){
                const cardHolder = component.querySelector('.saved-courses-holder');
                cardHolder.innerHTML = '<div><p>There are no saved courses.</p></div>';
            }

            function loadCourses(courses){
                const cardHolder = component.querySelector('.saved-courses-holder');
                cardHolder.innerHTML = '';

                courses.forEach(course => {
                    cardHolder.innerHTML += 
                    '<div class="course" data-path="' + course.path + '"><div class="close_btn"></div>' +
                        '<div class="preview"><a href="' + course.formattedPath + '">' +
                        '<img src="' + course.previewImagePath + '">' +
                        '</a></div>' +
                        '<div class="info">' +
                        '<div class="courses-tag">' + 
                        '<span class="tag tag-new" data-feature="' + course.aNew + '" data-enabled="' + tagNew +'">New</span>' + 
                        '<span class="tag tag-scholar" data-feature="' + course.scholarshipsAvailable + '" data-enabled="' + tagScholar + '">Scholarship Available</span>' +
                        '<span class="tag tag-online" data-feature="' + course.online + '" data-enabled="' + tagOnline + '">Online</span>' +
                        '<span class="tag tag-midyear" data-feature="' + course.midYearEntry + '" data-enabled="' + tagMidYear + '">Mid-year Entry</span></div>' +
                        '<div class="course-title"><a href="' + course.path + '">' + course.courseName + '</a></div>' +
                        '</div>' +
                    '</div>';
                });
            }

            initSavedCourses();
            monitorSavedCoursesChange('flinders_saved_courses', initSavedCourses);

            $(document).on('click', '.cmp-flindersonline-saved-courses .course .close_btn', function (e) {
                const target = $(this);
                const course = target.closest('.course');
                var pathToRemove = course.data('path');
                if (pathToRemove.endsWith(".html")) {
                    pathToRemove = pathToRemove.slice(0, -5); 
                }

                let saved = JSON.parse(localStorage.getItem('flinders_saved_courses') || '[]');
                saved = saved.filter(path => path !== pathToRemove);
                localStorage.setItem('flinders_saved_courses', JSON.stringify(saved));

                initSavedCourses();        
            });                
        })
    }
});